import styled from 'styled-components';

interface StyledProps {
  isVisible: boolean;
}

export const MapBox = styled.div<StyledProps>`
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 3;
  pointer-events: ${({ isVisible }) => (isVisible ? 'inherit' : 'none')};
  display: ${({ isVisible }) => (isVisible ? 'inherit' : 'none')};

  @media ${({ theme }) => theme.device.mobile} {
    height: calc(100% - 80px);
    top: 80px;
  }
`;
